import { InsightsDataLoader } from '@/components/Analysis/Insights/InsightsDataLoader';
import { PageLoader } from '@/components/shared/PageLoader';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { useFetchCookies, useRouter } from '@/hooks';
import { DefaultLayout } from '@/layouts/DefaultLayout';
import { Box } from '@mui/material';
import { Snackbar } from '@/components/shared/Snackbar';
import { useAtom } from 'jotai';
import * as state from '@/state';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';
import { InsightsExplorerKendo } from '@/components/Analysis/Insights/InsightsExplorerKendo';

export const InsightsKendoPage = () => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(state.snackbarMessage);
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  const closeSnack = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarMessage({ shouldShow: false, content: undefined });
  };

  const { shouldShow, content } = snackbarMessage;

  return (
    <DefaultLayout variant="analysis">
      <StructureCheck structureId={inspection}>
        <AccessGuard feature="insights" structureId={inspection}>
          <InsightsDataLoader>
            <Snackbar open={shouldShow} onClose={closeSnack}>
              {content}
            </Snackbar>
            <InsightsExplorerKendo />
          </InsightsDataLoader>
        </AccessGuard>
      </StructureCheck>
    </DefaultLayout>
  );
};
